import { apiClient } from './config'

const parseName = (name = '') => {
  const parts = name.trim().split(/\s+/)
  return {
    prenom: parts[0] || '',
    nom: parts.slice(1).join(' ') || '',
  }
}

/** Convertit le formulaire profil (FR) vers le payload API backend. */
export const toApiProfilePayload = (formData) => {
  const prenom = formData.prenom?.trim() ?? ''
  const nom = formData.nom?.trim() ?? ''
  const name = [prenom, nom].filter(Boolean).join(' ').trim()

  const payload = {}
  if (name) payload.name = name
  if (formData.ville !== undefined) payload.city = formData.ville.trim() || undefined
  if (formData.telephone !== undefined) payload.phone = formData.telephone.trim() || undefined
  if (formData.bio !== undefined) payload.bio = formData.bio.trim() || undefined
  return payload
}

/** Convertit un profil API vers les champs du formulaire. */
export const toProfileFormData = (user) => {
  if (!user) {
    return { prenom: '', nom: '', telephone: '', ville: '' }
  }

  const { prenom, nom } = user.prenom || user.nom
    ? { prenom: user.prenom || '', nom: user.nom || '' }
    : parseName(user.name)

  return {
    prenom,
    nom,
    telephone: user.phone ?? user.telephone ?? '',
    ville: user.city ?? user.ville ?? '',
  }
}

export const usersService = {
  async getMyProfile() {
    return apiClient.get('/users/me')
  },

  async updateMyProfile(formData) {
    return apiClient.patch('/users/me', toApiProfilePayload(formData))
  },

  async getUserById(id) {
    return apiClient.get(`/users/${id}`)
  },

  async submitKYC(documents) {
    return apiClient.post('/users/me/kyc', { documents })
  },

  async requestProStatus(documents) {
    return apiClient.post('/users/me/pro-status', { documents })
  },

  async getK6Request() {
    return apiClient.get('/users/me/k6-request')
  },

  async requestK6Access(reason) {
    return apiClient.post('/users/me/k6-request', { reason })
  },

  async getProRequest() {
    return apiClient.get('/users/me/pro-request')
  },

  async requestProAccess(reason) {
    return apiClient.post('/users/me/pro-request', { reason })
  },

  async activatePro() {
    return apiClient.post('/pro/activate', {})
  },

  async updateViewMode(viewMode) {
    return apiClient.post('/users/me/view-mode', { viewMode })
  },
}

export const portfolioService = {
  async getPortfolio() {
    return apiClient.get('/users/me/portfolio')
  },

  async updatePortfolio(portfolioData) {
    return apiClient.patch('/users/me/portfolio', { portfolioData })
  },

  async uploadPhoto(file, caption) {
    const formData = new FormData()
    formData.append('file', file)
    if (caption) {
      formData.append('caption', caption)
    }
    return apiClient.post('/users/me/portfolio/photos', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  async uploadImage(file, type) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)
    return apiClient.post('/users/me/portfolio/images', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  async deletePhoto(photoId) {
    return apiClient.delete(`/users/me/portfolio/photos/${photoId}`)
  },

  async reorderPhotos(order) {
    return apiClient.patch('/users/me/portfolio/photos/reorder', { order })
  },
}
